module.exports = __webpack_public_path__ + "static/media/r36.090f1ec2.jpg";